const routes = [
  {
    path: 'waterprogress',
    component: () => import(/* webpackChunkName: "waterprogress" */ '@/modules/waterprogress/index.vue'),
    children: [
      {
        path: '',
        name: 'waterprogress',
        component: () => import(/* webpackChunkName: "demo1" */ '@/modules/waterprogress/demo1.vue'),
      },
      {
        path: 'demo1',
        component: () => import(/* webpackChunkName: "demo1" */ '@/modules/waterprogress/demo1.vue'),
      },
      {
        path: 'demo2',
        component: () => import(/* webpackChunkName: "demo2" */ '@/modules/waterprogress/demo2.vue'),
      },
    ],
  },
];

export default routes;